<template>
  <div class="wd-100p ht-100p">
    <!-- <Header></Header> -->
    <div class="wd-100p ht-100p">
      <div class="wd-100p ht-100p pos-r">
        <mv-full-page
          :isPointer="false"
          height="100%"
          position="relative"
          pointerPos="right"
          :isV="isV"
          :pages="pages"
          :page.sync="page"
          :bgArr="bgArr"
          :isCache="true"
          :transition="{
            duration: '900ms', // 动画时长
            timingFun: 'ease', // 动画速度曲线
            delay: '0s', // 动画延迟
          }"
          @rollEnd="onRollEnd"
          :config="config"
          @pointerMouseover="pointerMouseover"
        >
          <!-- 动态插槽 -->
          <!-- <template v-slot:[dynamicSlotName+page] v-for="page in pages">
            <div :class="`page${page}`" :key="page">
              {{ `页面${page}` }}
            </div>
          </template> -->
          <!-- bounceIn、bounceInDown、bounceInUp、bounceInLeft、bounceInRight---动画 -->
          <!-- 静态插槽 -->
          <template #page1>
            <div class="wd-100p ht-100p ov-h ov-a-y">
              <div class="wd-100p ht-100p bg-white" v-animate="{ name: 'bounceInLeft', delay: 0}">
                  <div class="wd-100p pos-r dp-flex">
                    <img v-if="!$store.state.mob" class="wd-100p" src="@/assets/home/bg.jpg"/>
                    <img v-else class="wd-100p ht-100vh" src="@/assets/home/bg_mob.jpg"/>                    
                    <div class="pos-a bg-1  dp-flex jus-c cr-white fw pointer" 
                         :class="$store.state.mob?'wd-50p left-25p bottom-15p font-20 ht-50':'wd-20p left-50p bottom-4p font-30 ht-60'" 
                    @click="clickref('/virtual')" v-animate="{ name: 'bounceInUp', delay: 600 }">
                      Click to Experience
                    </div>
                  </div>
                  <div class="pos-r" v-if="!$store.state.mob">                    
                    <div class="wd-100p pos-a txt-ali-c cr-theme0 pd-20 font-16 Roboto">
                      FRASER SUITES HANOI <br/>
                      51 Xuan Dieu Street, Quang An, Tay Ho District, Hanoi, Vietnam<br/>
                      Tel : +84 24 3719 8877    Email :sales.hanoi@frasershospitality.com<br/>
                      Airport transfer is available on request
                    </div>
                    <img class="wd-100p" src="@/assets/home/foot.png"/>
                  </div>
              </div>
            </div>
          </template>
        </mv-full-page>
      </div>
    </div>
  </div>
</template>

<script>
import MvFullPage from "@/components/MvFullPage/index.vue";
// import Header from "@/components/header.vue";
export default {
  components: { 
    // Header,
    MvFullPage 
  },
  data() {
    return {
      dynamicSlotName: "page",
      pages: 1, // 页面总数
      tempPage: 1,
      isV: true, //滚动的方向 true 为垂直方向，false 为左右方向
      page: 1, // 当前页面
      bgArr: [],
      config: {
        // 自动播放
        autoPlay: false,
        //  循环播放
        loop: false,
        // 切换间隔
        interval: 1000,
        // 上一页箭头
        lastArrow: false,
        // 下一页箭头
        nextArrow: false,
      },
    };
  },
  methods: {
    pointerMouseover({ event, index }) {
      console.log(event, index);
    },
    onRollEnd(page) {
      // console.log("当前页面为", page);
    },
    toPage() {
      this.page = this.tempPage;
    },
    clickref(ref) {
      this.pushr(ref);
    },
  },
  computed: {
  },
  created() {},
  mounted() {    
    this.$store.dispatch("getMob");
  },
  watch: {},
  beforeDestroy() {},
};
</script>